<div class="list-card">
  <div class="list-container">
    <div class="heading">

      <h3 class="list-heading"><i class="fa fa-sitemap heading-icon"></i>Hierarchy</h3>
    </div>
    <div class="button-container">
        <ng-select placeholder="Select Term" [(ngModel)]="selectedTermId" [items]="termarr" class="termselect" (change)="inputchange()"  [bindLabel]="'di_bus_nm'">
            <ng-template ng-option-tmp let-item="item">
              <div title="{{item?.di_tech_nm}}">
                {{item?.di_bus_nm}}
              </div>
            </ng-template>
          </ng-select>
      <button mat-raised-button class="button-right add-button" *ngIf="listflag" (click)="onAddButtonClick()">
        <i class="fa fa-plus"></i> Add
      </button>
      <button mat-raised-button class="button-right add-button" *ngIf="addflag || updateflag || viewflag"
        (click)="gotolist()">
        <i class="fa fa-plus"></i> List
      </button>
    </div>
    <div *ngIf="listflag">
      <lib-list [config]="CL" (onViewItemEvent)="onViewClicked($event)" (onUpdateItemEvent)="onUpdateClicked($event)">
      </lib-list>
    </div>
    <div *ngIf="addflag || viewflag || updateflag">
      <mat-card class="example-card1">
        <div class="input-container">
          <mat-form-field class="input">
            <input matInput placeholder="Hierarchy code" id="cd" [(ngModel)]="data['cl_cd']" required>

            <mat-icon matSuffix matTooltip="Enter the code for the hierarchy" color="primary">info</mat-icon>
            <mat-error *ngIf="!data.cl_cd">Hierarchy Code is required</mat-error>
          </mat-form-field>
        </div>

        <div class="input-container">
          <mat-form-field class="input">
            <input matInput placeholder="Hierarchy Name" id="value" [(ngModel)]="data['cl_val']" required>

            <mat-icon matSuffix matTooltip="Enter the name of the hierarchy" color="primary">info</mat-icon>
            <mat-error *ngIf="!data.cl_val">Hierarchy Name is required</mat-error>
          </mat-form-field>
        </div>

        <div class="input-container">
          <mat-form-field class="input">
            <textarea matInput placeholder="Hierarchy Description" id="description" [(ngModel)]="data['cl_desc']"
              rows="3"></textarea>
         
            <mat-icon matSuffix matTooltip="Provide a brief description of the hierarchy" color="primary">info
            </mat-icon>
          </mat-form-field>
        </div>
      </mat-card>
      <br>
      <div class="row">
        <div class="col-12 button-container">
          <button mat-button color="primary" (click)="submit()" *ngIf="addflag">Submit</button>
          <button mat-button color="primary" (click)="update()" *ngIf="updateflag">Update</button>
        </div>
      </div>
    </div>

  </div>

</div>
